import React, { useContext } from "react";

// Context
import AppContext from "./AppContext";

// Css
import "./ToolBar.css";

// Components
import Tool from "./Tool";
import ColorBar from "./ColorBar";
import SmallBar from "./SmallBar";
import ToolbarDragger from "./ToolbarDragger";

// Material Ui
// #Transitions
import Slide from "@material-ui/core/Slide";

function ToolBar() {
  const { appContext } = useContext(AppContext);
  const { toolBarOn } = appContext;
  return (
    <div>
      <Slide in={toolBarOn} direction="up">
        <div className="toolbar">
          <ToolbarDragger />
          <SmallBar />
          <ColorBar parent="toolbar" />
          <div className="toolbar__container">
            <Tool buttonType="bold" zoomDelay="0.1s" />
            <Tool buttonType="italic" zoomDelay="0.2s" />
            <Tool buttonType="underline" zoomDelay="0.3s" />
            <Tool buttonType="strikeThrough" zoomDelay="0.4s" />
          </div>
        </div>
      </Slide>
    </div>
  );
}

export default ToolBar;
